<template>
  <div class="main-links">
    <div class="inner">
      <div class="lg-none">
        <router-link
          class="link"
          :class="{isActiveLink: $route.meta.key === 1}"
          :to="{name: 'shop-center'}"
        >Торговым центрам</router-link>
      </div>
      <div class="lg-appear w-100">
        <div class="link-container">
          <button
            :class="{isActiveLink: $route.meta.key === 1}"
            class="link border-none"
            v-b-toggle.:id="id"
          >
            Торговым центрам
            <img class="arrow" src="@/assets/images/arrow.svg" alt />
          </button>
          <b-collapse :id="id">
            <router-link
              class="shop-link"
              :class="{isActiveShopLink: $route.meta.index === 1}"
              :to="{name: 'autoReg'}"
            >Автоматизиованная стойка регистрации</router-link>
            <router-link
              class="shop-link"
              :class="{isActiveShopLink: $route.meta.index === 2}"
              :to="{name: 'independReg'}"
            >Самостоятельная регистрация</router-link>
            <router-link
              class="shop-link"
              :class="{isActiveShopLink: $route.meta.index === 3}"
              :to="{name: 'loyalProgram'}"
            >Программа лояльностей покупателей ТРЦ</router-link>
          </b-collapse>
        </div>
      </div>
      <router-link
        class="link"
        :class="{isActiveLink: $route.meta.key === 2}"
        :to="{name: 'brands'}"
      >
        FMCG Брендам
        <img class="arrow" src="@/assets/images/arrow.svg" alt />
      </router-link>
      <router-link
        class="link"
        :class="{isActiveLink: $route.meta.key === 3}"
        :to="{name: 'franchisors'}"
      >
        Франчайзерам
        <img class="arrow" src="@/assets/images/arrow.svg" alt />
      </router-link>
    </div>
  </div>
</template>


<script>
import ShopNav from "./shop-nav";
export default {
  components: {
    ShopNav
  },
  props: {
    id: String
  }
};
</script>